module.exports = __webpack_public_path__ + "static/img/组 10@2x.157b5956.png";